import type { BaseController } from '@infra/controllers/base.controller';
import type {
  SyncIntegrationSettingUpdateRequest,
  SyncIntegrationSettingUpdateResponse,
  SyncIntegrationSettingUpdateUsecase,
} from '@usecases/sync-integration-setting-update.usecase';

export type SyncIntegrationSettingUpdateInput =
  SyncIntegrationSettingUpdateRequest;

export type SyncIntegrationSettingUpdateOutput =
  SyncIntegrationSettingUpdateResponse;

export class SyncIntegrationSettingUpdateController
  implements
    BaseController<
      SyncIntegrationSettingUpdateInput,
      SyncIntegrationSettingUpdateOutput
    >
{
  constructor(private usecase: SyncIntegrationSettingUpdateUsecase) {}
  async handle(
    req: SyncIntegrationSettingUpdateInput,
  ): Promise<SyncIntegrationSettingUpdateOutput> {
    return await this.usecase.run(req);
  }
}
